import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PostSearch } from '../../models/asset/search';
import { Asset } from '../../models/asset/asset';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class AssetProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/asset';

  public searchByAssetId(body: PostSearch): Observable<ApiResponse<PaginatedApiResponse<Asset>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Asset>>>(`${this.baseUrl}/search`, body);
  }
}
